module.exports = __webpack_public_path__ + "static/media/moviemizer_icon.05c282b4.png";